// extracted by mini-css-extract-plugin
module.exports = {"icon":"myIcon_icon__W7QxF"};